import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "../../../common/AppBar";
import Snackbar from "../../../common/Snackbar";

import { getAllSectionsForPart } from "../../../redux/sectionSlice";
import {
  getAllAttachmentsForStep,
  getAllAttachmentsForSubstep,
  getAllCanvasesForStep,
  getAllCanvasesForSubstep,
  getAllFormsForStep,
  getAllFormsForSubstep,
  getAllRichTextsForStep,
  getAllRichTextsForSubstep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
  getAllVideosForSubstep,
} from "../../../redux/stepSlice";
import VersionHistoryCopyAppBar from "../../../common/VersionHistoryCopyAppBar";
import { getPages, renderVideo } from "../plugins/utils";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../../SectionElements/plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import { generateCompleteTreePath } from "../../SubassemblyDetails/utils/treePathUtils";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import { renderPreview } from "../plugins/utils";
const ProcedureChildCopy = () => {
  // Moved definition to the top so it's available when needed
  const location = useLocation();
  const {
    type,
    partNumber,
    description,
    revision,
    status,
    title,
    partId,
    fromTreeId,
    fromSectionId,
    revisionId,
    fromSiblingOrder,
    fromPartNumber,
    fromRevision,
    toPartNumber,
    toRevision,
    richTextsByStep,
    attachmentsByStep,
    canvasesByStep,
    formsByStep,
    videosByStep,
    section,
    steps,
    toRevisionId,
    step,
    substep,
    node,
    nodeType,
    fromNodeId,
    sourceStepId,
    fromSubstepId,
    fromPartId,
    fromRevisionId,
    toType,
    sourceSectionIndex,
    sourceStepIndex,
    sourceSubstepIndex,
    childTreeId,
    fromSubstepLetter,
    copyTitle,
  } = location.state;

  // Extract source information from title at the top level
  const titleParts = title.split(" ");
  const sourceType = titleParts.slice(0, -1).join(" "); // e.g., "Rich Text", "Video"
  const sourceNumber = parseInt(titleParts[titleParts.length - 1], 10); // e.g., 1, 2, 3

  let globalRichTextCounter = 1;
  let globalAttachmentCounter = 1; // Renamed for clarity and consistency
  let globalVideoCounter = 1;
  let globalFormCounter = 1;
  let globalCanvasCounter = 1;

  const [targetSectionData, setTargetSectionData] = useState({});
  const [selectedNode, setSelectedNode] = useState("");
  const [selectedStepInfo, setSelectedStepInfo] = useState(null);
  const [selectionType, setSelectionType] = useState(null); // 'section' or 'step' or 'node'
  const [selectedNodeInfo, setSelectedNodeInfo] = useState(null);

  const { sections } = useSelector((state) => state.section);
  // let richTextCounter = 1; // These are now global
  // let canvasCounter = 1;
  // let videoCounter = 1;
  // let formCounter = 1;

  let richTextsCounter = {}; // This can remain local if only used in rendering loop

  const navigate = useNavigate();
  // let attachmentCounter = 1; // This is now global

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
  const dispatch = useDispatch();

  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [firstWord, secondWord, thirdWord] = title.split(" ");

  // Calculate substep letter if not provided
  let substepLetter = fromSubstepLetter;
  if (!substepLetter && sourceSubstepIndex !== undefined) {
    // Use sourceSubstepIndex to calculate the substep letter
    // Note: sourceSubstepIndex is 0-based, but substep letters start from A (65)
    substepLetter = String.fromCharCode(65 + sourceSubstepIndex);
  } else if (!substepLetter && fromSubstepId) {
    // Fallback: if we have fromSubstepId but no sourceSubstepIndex, default to A
    substepLetter = "A";
  }

  const treeNode = `Section ${
    sourceSectionIndex !== undefined && sourceSectionIndex !== null
      ? sourceSectionIndex + 1
      : "Unknown"
  } > Step ${sourceStepIndex + 1} > ${
    substepLetter ? `Substep ${sourceStepIndex + 1}${substepLetter} > ` : ""
  }${firstWord} ${secondWord}${
    firstWord === "Rich" && thirdWord ? " " + thirdWord : ""
  }`;

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const sortedSections = [...sections];

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  useEffect(() => {
    dispatch(getAllSectionsForPart({ partId, revisionId: toRevisionId }));
  }, [dispatch, partId, revisionId, toRevisionId]); // Added toRevisionId to dependency array

  useEffect(() => {
    if (sections.length > 0) {
      sections.forEach(async (section) => {
        await dispatch(
          getAllStepsForSection({
            partId,
            revisionId,
            sectionId: section.section_tree_node_id,
          })
        );
      });
    }
  }, [sections, dispatch, partId, revisionId]);

  useEffect(() => {
    if (Object.keys(stepsBySection).length > 0) {
      Object.entries(stepsBySection).forEach(([sectionId, steps]) => {
        steps.forEach((step) => {
          const { step_tree_node_id: stepId } = step;

          // // Fetch for step-level content
          dispatch(
            getAllRichTextsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllFormsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllVideosForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllAttachmentsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllCanvasesForStep({ partId, revisionId, sectionId, stepId })
          );

          // Fetch substeps (async)
          dispatch(
            getAllSubstepsForStep({ partId, revisionId, sectionId, stepId })
          ).then((action) => {
            const substeps = action.payload?.substeps || [];
            substeps.forEach((substep) => {
              const substepId = substep.sub_step_tree_node_id;

              dispatch(
                getAllRichTextsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllFormsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllVideosForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllAttachmentsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllCanvasesForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
            });
          });
        });
      });
    }
  }, [sections, dispatch, partId, revisionId, stepsBySection]);

  const handleMoveUp = () => {
    const targetSectionIndex = selectedSectionIndex;
    const { richTexts, attachments, forms, canvases, videos } = location.state;

    navigate("/procedure-child-copy-preview", {
      state: {
        ...location.state,
        moveType: "up",
        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : selectionType === "substep"
            ? `Substep ${selectedNodeInfo?.globalNodeNumber || ""}`
            : selectionType === "node"
            ? `${selectedNodeInfo?.nodeType || ""} ${
                selectedNodeInfo?.globalNodeNumber || ""
              }`
            : ""
        }`,

        sourceSectionIndex,
        targetSectionIndex: selectedSectionIndex,
        targetNodeType: selectedNodeInfo?.nodeType || selectionType,
        sourceStepId,
        fromSubstepId,
        revision,
        type,
        fromPartId,
        fromRevisionId,
        partNumber,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        section,
        steps,
        step,
        substep,
        richTexts,
        forms,
        videos,
        canvases,
        attachments,
        node,
        nodeType,
        fromNodeId,
        status,
        toType,
        description,
        childTreeId,
        toPartNumber,
        treeNode,
        revision: fromRevision,

        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };

  const handleMoveBelow = () => {
    const targetSectionIndex = selectedSectionIndex;
    const { richTexts, attachments, forms, canvases, videos } = location.state;

    navigate("/procedure-child-copy-preview", {
      state: {
        ...location.state,
        moveType: "below",
        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : selectionType === "substep"
            ? `Substep ${selectedNodeInfo?.globalNodeNumber || ""}`
            : selectionType === "node"
            ? `${selectedNodeInfo?.nodeType || ""} ${
                selectedNodeInfo?.globalNodeNumber || ""
              }`
            : ""
        }`,
        sourceSectionIndex,
        targetSectionIndex: selectedSectionIndex,
        targetNodeType: selectedNodeInfo?.nodeType || selectionType,
        fromSubstepId,
        fromPartId,
        fromRevisionId,
        sourceStepId,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        node,
        nodeType,
        fromNodeId,
        section,
        steps,
        step,
        substep,
        richTexts,
        forms,
        videos,
        canvases,
        attachments,
        status,
        toType,
        description,
        toPartNumber,
        childTreeId,
        treeNode,
        revision: fromRevision,

        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };

  const handleMoveInto = () => {
    const { richTexts, attachments, forms, canvases, videos } = location.state;

    navigate("/procedure-child-copy-preview", {
      state: {
        ...location.state,
        moveType: "into", // Use "into" for pasting into a step/substep
        sourceSectionIndex,
        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : selectionType === "substep"
            ? `Substep ${selectedNodeInfo?.globalNodeNumber || ""}`
            : selectionType === "node"
            ? `${selectedNodeInfo?.nodeType || ""} ${
                selectedNodeInfo?.globalNodeNumber || ""
              }`
            : ""
        }`,
        targetSectionIndex: targetSectionData.sectionIndex || 0, // Use the actual section index where the step is located
        moveIntoProcedure: true, // Add a flag to indicate this is a move into procedure
        revisionId,
        targetNodeType: selectedNodeInfo?.nodeType || selectionType,
        sourceStepId,
        fromSubstepId,
        fromPartId,
        fromRevisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        section,
        steps,
        step,
        substep,
        richTexts,
        forms,
        videos,
        canvases,
        attachments,
        node,
        nodeType,
        fromNodeId,
        status,
        toType,
        description,
        toPartNumber,
        childTreeId,
        treeNode,
        revision: fromRevision,
        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };

  // Create buttons array conditionally based on selection state
  const getButtons = () => {
    const buttons = [];
    if (selectionType === "substep") {
      buttons.push({ label: "Paste Into", onClick: handleMoveInto });
    } else if (selectionType === "step") {
      buttons.push({ label: "Paste Into", onClick: handleMoveInto });
    } else if (selectionType === "node") {
      buttons.push({ label: "Paste Above", onClick: handleMoveUp });
      buttons.push({ label: "Paste Below", onClick: handleMoveBelow });
    } else {
      // Show no buttons when no checkbox is selected
      // No buttons shown when no checkbox is selected
    }
    return buttons;
  };

  return (
    <div>
      <VersionHistoryCopyAppBar
        showTablesDropdown={false}
        showCancelButton={true}
        showBackButton={false}
        title={
          <>
            Copying <span style={{ textDecoration: "underline" }}>{title}</span>{" "}
            from {fromPartNumber} Rev {fromRevision} to {toPartNumber} Rev{" "}
            {toRevision}{" "}
            <span style={{ textDecoration: "underline" }}>
              {selectionType === "step"
                ? "Step " +
                  (selectedStepInfo?.globalStepNumber ||
                    targetSectionData.stepIndex + 1)
                : selectionType === "substep"
                ? "Substep " + (selectedNodeInfo?.globalNodeNumber || "")
                : selectionType === "node"
                ? (selectedNodeInfo?.nodeType || "") +
                  " " +
                  selectedNodeInfo?.globalNodeNumber
                : ""}
            </span>
          </>
        }
        buttons={getButtons()}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 0",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          className="header-spacing"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            <span style={{ fontSize: "19px", fontWeight: 600 }}>
              {toType} {toPartNumber}
            </span>
          </label>

          {/* Description */}
          {/* <span style={{ marginLeft: "2px", marginTop: "5px", color: "#666" }}>
            Description: {description}
          </span> */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>{status}</span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>

      {sortedSections
        .sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        })
        .map((section, index) => {
          const selectedSection = index === selectedSectionIndex;
          // const isDisabled = selectedSection; // This variable is not used

          return (
            <div
              className="header-spacing"
              key={section.section_tree_node_id}
              style={{
                margin: "20px 0",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <h2 style={{ margin: 0, fontSize: "20px" }}>
                  Section {index + 1}
                </h2>
                {selectedSection && (
                  <span
                    style={{
                      marginLeft: "12px",
                      fontSize: "14px",
                      color: "#666",
                      fontStyle: "italic",
                    }}
                  >
                    {/* (Current Section Being Moved) */}
                  </span>
                )}
              </label>
              <hr />
              <hr />
              <div>{section.section_name}</div>
              <div>{section.short_description}</div>

              {/* Steps for this section */}
              {(stepsBySection[section.section_tree_node_id] || []).map(
                (step, stepIndex) => {
                  const stepId = step.step_tree_node_id;

                  const stepsBeforeThisSection = sortedSections
                    .slice(0, index)
                    .reduce(
                      (acc, s) =>
                        acc +
                        (stepsBySection[s.section_tree_node_id]?.length || 0),
                      0
                    );
                  const globalStepNumber =
                    stepsBeforeThisSection + stepIndex + 1;

                  // Reset counters for each step to ensure correct numbering within the step
                  // globalRichTextCounter = 1;
                  // globalAttachmentCounter = 1;
                  // globalVideoCounter = 1;
                  // globalFormCounter = 1;
                  // globalCanvasCounter = 1;

                  const isSourceStep =
                    globalStepNumber === sourceNumber && sourceType === "Step";

                  const combinedItems = [
                    ...(richTexts[stepId] || []).map((item) => ({
                      ...item,
                      type: "richText",
                    })),
                    ...(forms[stepId] || []).map((item) => ({
                      ...item,
                      type: "form",
                    })),
                    ...(attachments[stepId] || []).map((item) => ({
                      ...item,
                      type: "attachment",
                    })),
                    ...(canvases[stepId] || []).map((item) => ({
                      ...item,
                      type: "canvas",
                    })),
                    ...(videos[stepId] || []).map((item) => ({
                      ...item,
                      type: "video",
                    })),
                  ];
                  const filteredItems = combinedItems.filter(
                    (item) =>
                      !item.substep_id_ref && !item.sub_step_tree_node_id
                  );

                  filteredItems.sort((a, b) => {
                    const orderA =
                      a.sibling_order || a.procedure_tree?.sibling_order;
                    const orderB =
                      b.sibling_order || b.procedure_tree?.sibling_order;

                    const orderCompare = compareSiblingOrders(orderA, orderB);
                    if (orderCompare !== 0) return orderCompare;

                    // Fallback: compare created_at
                    const dateA = new Date(a.created_at);
                    const dateB = new Date(b.created_at);
                    return dateB - dateA; // latest comes first
                  });

                  const maxSiblingOrder = Math.max(
                    ...filteredItems.map((item) =>
                      parseInt(
                        item.sibling_order ||
                          item.procedure_tree?.sibling_order ||
                          0
                      )
                    )
                  );

                  return (
                    <div
                      className="header-spacing"
                      key={stepId}
                      style={{ marginTop: "20px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            gap: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            onChange={() => {
                              if (
                                selectedStepInfo &&
                                selectedStepInfo.stepId === stepId
                              ) {
                                setSelectedStepInfo(null);
                                setSelectionType(null);
                              } else {
                                let highestOrder = 0;
                                filteredItems.forEach((item) => {
                                  const order = parseInt(
                                    item.sibling_order || 0
                                  );
                                  if (!isNaN(order) && order > highestOrder) {
                                    highestOrder = order;
                                  }
                                });

                                // Get accurate sibling order from the step data
                                const stepOrder =
                                  step.sibling_order ||
                                  step.procedure_tree?.sibling_order;
                                setSelectedStepInfo({
                                  stepId,
                                  sectionIndex: index,
                                  stepIndex: stepIndex,
                                  globalStepNumber,
                                  direction: null,
                                });
                                setTargetSectionData({
                                  sectionId: section.section_tree_node_id,
                                  sectionIndex: index, // Add the section index
                                  siblingOrder: (highestOrder + 1).toString(),
                                  sectionTreeId: section.section_tree_node_id,
                                  stepId,
                                  stepTreeId: step.procedure_tree_ref,
                                  stepSiblingOrder: stepOrder,
                                  step: { ...step }, // Keep the full step data
                                  stepIndex,
                                  globalStepNumber,
                                  maxSiblingOrder,
                                });
                                setSelectedSectionIndex(null);
                                setSelectionType("step");
                              }
                            }}
                            checked={
                              (selectedStepInfo &&
                                selectedStepInfo.stepId === stepId &&
                                selectionType === "step") ||
                              false
                            }
                            style={
                              selectedStepInfo &&
                              selectedStepInfo.stepId === stepId &&
                              selectionType === "step"
                                ? {
                                    accentColor: "#0066cc", // Blue for selected step
                                    backgroundColor: "#0066cc",
                                  }
                                : {}
                            }
                            disabled={false}
                          />
                          <h2
                            style={{
                              margin: 0,
                              color: "#0066cc",
                              fontSize: "20px",
                            }}
                          >
                            Step {globalStepNumber}
                          </h2>
                        </label>

                        <div
                          style={{
                            color: "#888",
                            fontSize: "14px",
                            fontWeight: "normal",
                          }}
                        >
                          {generateCompleteTreePath({
                            sectionIndex: index,
                            stepIndex: globalStepNumber - 1,
                            substepIndex: undefined,
                            nodeType: undefined,
                            nodeIndex: undefined,
                          })}
                        </div>
                      </div>
                      <hr />
                      <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                      <p>
                        <p>
                          {structuredClone(step.step_details)
                            .sort(
                              (a, b) =>
                                new Date(a.created_at) - new Date(b.created_at)
                            )
                            .map((myStep, index) => {
                              const partNumber =
                                myStep.part_info?.part_number || "";
                              const description =
                                myStep.part_info?.description || "";
                              const qtyText =
                                myStep.qty && myStep.qty !== 0
                                  ? `Qty ${myStep.qty}`
                                  : "";

                              const partText = partNumber
                                ? ` (${partNumber})`
                                : "";

                              return (
                                <span key={index}>
                                  {myStep.action}
                                  {partText}{" "}
                                  <RenderHtml content={description} /> {qtyText}
                                  &nbsp;
                                </span>
                              );
                            })}
                        </p>
                      </p>

                      <h4>{step.bom_table_title_info?.category_name || ""}</h4>

                      <table className="table">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>
                              {
                                step.part_number_column_title_ref_info
                                  ?.category_name
                              }{" "}
                            </th>
                            <th>Description</th>
                            <th>Qty Per</th>
                            <th>Unit</th>
                          </tr>
                        </thead>

                        <tbody>
                          {step.parts_required.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {" "}
                              {/* Added key for list rendering */}
                              <td>{row.part_info.type_info.name}</td>
                              <td>{row.part_info.part_number}</td>
                              <td>
                                <RenderHtml
                                  content={row.part_info.description}
                                />{" "}
                              </td>
                              <td>{row.qty === 0 ? "" : row.qty}</td>
                              <td>{row.part_info?.unit_info?.unit_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {/* Step Content */}
                      {filteredItems.map((item, itemIndex) => {
                        // Determine if this is the source item being moved
                        const isSourceItem =
                          (sourceType === "Rich Text" &&
                            item.type === "richText" &&
                            globalRichTextCounter === sourceNumber) ||
                          (sourceType === "Form" &&
                            item.type === "form" &&
                            globalFormCounter === sourceNumber) ||
                          (sourceType === "Canvas" &&
                            item.type === "canvas" &&
                            globalCanvasCounter === sourceNumber) ||
                          (sourceType === "Video" &&
                            item.type === "video" &&
                            globalVideoCounter === sourceNumber) ||
                          (sourceType === "Attachment" &&
                            item.type === "attachment" &&
                            globalAttachmentCounter === sourceNumber);

                        switch (item.type) {
                          case "richText": {
                            const currentRichTextNumber =
                              globalRichTextCounter++;
                            const richTextId =
                              item.rich_text_node_id ||
                              `rich-text-${currentRichTextNumber}`;
                            const label = (
                              <h2
                                style={{ color: "#0066cc", fontSize: "20px" }}
                              >
                                Rich Text {currentRichTextNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={richTextId}
                                style={{ marginTop: "20px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId === richTextId
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          const nodeType = "Rich Text";
                                          setSelectionType("node");

                                          setSelectedNodeInfo({
                                            nodeId: richTextId,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            nodeIndex: itemIndex,
                                            globalNodeNumber:
                                              currentRichTextNumber,
                                            nodeType: "Rich Text",
                                            direction: null,
                                            stepId,
                                          });

                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            elementSiblingOrder:
                                              item.sibling_order,
                                            elementId: item.rich_text_node_id,
                                            elementTreeId:
                                              item.procedure_tree_ref,
                                          });
                                        }
                                      }}
                                      checked={
                                        (selectionType === "node" &&
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            richTextId &&
                                          selectedNodeInfo.nodeType ===
                                            "Rich Text") ||
                                        false
                                      }
                                      disabled={false} // Allow selection even if it's the source item
                                    />
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {generateCompleteTreePath({
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: undefined,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    })}
                                  </div>
                                </div>

                                <div
                                  style={{
                                    marginLeft: "5px",
                                    marginTop: "-10px",
                                  }}
                                >
                                  {item.short_description}
                                </div>
                                <div
                                  style={{
                                    marginLeft: "4px",
                                    marginTop: "5px",
                                  }}
                                >
                                  {item.category_data?.category_name}
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "4px",
                                    marginTop: "5px",
                                  }}
                                >
                                  <div
                                    style={{ marginTop: "-6px" }}
                                    dangerouslySetInnerHTML={{
                                      __html: item.rich_text_content,
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                          case "video": {
                            const currentVideoNumber = globalVideoCounter++;
                            const label = (
                              <h2
                                style={{ color: "#0066cc", fontSize: "20px" }}
                              >
                                Video {currentVideoNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={
                                  item.video_tree_node_id ||
                                  `video-${currentVideoNumber}`
                                }
                                style={{ marginTop: "20px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.video_tree_node_id
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          setSelectedStepInfo(null);
                                          setSelectedNodeInfo({
                                            nodeId: item.video_tree_node_id,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            nodeIndex: itemIndex,
                                            globalNodeNumber:
                                              currentVideoNumber,
                                            nodeType: "Video",
                                            direction: null,
                                            stepId,
                                          });
                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            elementSiblingOrder:
                                              item.sibling_order,
                                            elementId: item.video_tree_node_id,
                                            elementTreeId:
                                              item.procedure_tree_ref,
                                          });
                                          setSelectionType("node");
                                        }
                                      }}
                                      checked={
                                        (selectionType === "node" &&
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.video_tree_node_id &&
                                          selectedNodeInfo.nodeType ===
                                            "Video") ||
                                        false
                                      }
                                      disabled={false} // Allow selection even if it's the source item
                                    />
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {generateCompleteTreePath({
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: undefined,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    })}
                                  </div>
                                </div>

                                {renderVideo(item)}

                                <div>{item.video_url}</div>

                                <div>{item.short_description}</div>
                              </div>
                            );
                          }

                          case "form": {
                            const currentFormNumber = globalFormCounter++;
                            const label = (
                              <h2
                                style={{ color: "#0066cc", fontSize: "20px" }}
                              >
                                Form {currentFormNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={
                                  item.form_tree_node_id ||
                                  `form-${currentFormNumber}`
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.form_tree_node_id
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          setSelectedStepInfo(null);
                                          setSelectedNodeInfo({
                                            nodeId: item.form_tree_node_id,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            nodeIndex: itemIndex,
                                            globalNodeNumber: currentFormNumber,
                                            nodeType: "Form",
                                            direction: null,
                                            stepId,
                                          });
                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            elementSiblingOrder:
                                              item.sibling_order,
                                            elementId: item.form_tree_node_id,
                                            elementTreeId:
                                              item.procedure_tree_ref,
                                          });
                                          setSelectionType("node");
                                        }
                                      }}
                                      checked={
                                        (selectionType === "node" &&
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.form_tree_node_id &&
                                          selectedNodeInfo.nodeType ===
                                            "Form") ||
                                        false
                                      }
                                      disabled={false} // Allow selection even if it's the source item
                                    />
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {generateCompleteTreePath({
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: undefined,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    })}
                                  </div>
                                </div>
                                <div>{item.short_description}</div>
                              </div>
                            );
                          }
                          case "canvas": {
                            const pages = getPages(item);

                            const currentCanvasNumber = globalCanvasCounter++;
                            const label = (
                              <h2
                                style={{ color: "#0066cc", fontSize: "20px" }}
                              >
                                Canvas {currentCanvasNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={
                                  item.canvas_tree_node_id ||
                                  `canvas-${currentCanvasNumber}`
                                }
                                style={{ marginTop: "20px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.canvas_tree_node_id
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          setSelectedStepInfo(null);
                                          setSelectedNodeInfo({
                                            nodeId: item.canvas_tree_node_id,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            nodeIndex: itemIndex,
                                            globalNodeNumber:
                                              currentCanvasNumber,
                                            nodeType: "Canvas",
                                            direction: null,
                                            stepId,
                                          });
                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            elementSiblingOrder:
                                              item.sibling_order,
                                            elementId: item.canvas_tree_node_id,
                                            elementTreeId:
                                              item.procedure_tree_ref,
                                          });
                                          setSelectionType("node");
                                        }
                                      }}
                                      checked={
                                        (selectionType === "node" &&
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.canvas_tree_node_id &&
                                          selectedNodeInfo.nodeType ===
                                            "Canvas") ||
                                        false
                                      }
                                      disabled={false} // Allow selection even if it's the source item
                                    />
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {generateCompleteTreePath({
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: undefined,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    })}
                                  </div>
                                </div>

                                {/* Display all pages vertically */}
                                <CanvasDisplay pages={pages} />
                              </div>
                            );
                          }
                          case "attachment": {
                            const attachmentList = item.attachments || [];
                            if (attachmentList.length === 0) return null;

                            const currentAttachmentNumber =
                              globalAttachmentCounter++;

                            const label = (
                              <h2
                                style={{ color: "#0066cc", fontSize: "20px" }}
                              >
                                Attachment {currentAttachmentNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={
                                  item.attachment_tree_node_id ||
                                  `attachment-${currentAttachmentNumber}`
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.attachment_tree_node_id
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          setSelectedNodeInfo({
                                            nodeId:
                                              item.attachment_tree_node_id,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            nodeIndex: itemIndex,
                                            globalNodeNumber:
                                              currentAttachmentNumber,
                                            nodeType: "Attachment",
                                            direction: null,
                                            stepId,
                                          });
                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            elementSiblingOrder:
                                              item.sibling_order,
                                            elementId:
                                              item.attachment_tree_node_id,
                                            elementTreeId:
                                              item.procedure_tree_ref,
                                          });
                                          setSelectionType("node");
                                        }
                                      }}
                                      checked={
                                        (selectionType === "node" &&
                                          selectedNodeInfo &&
                                          selectedNodeInfo.nodeId ===
                                            item.attachment_tree_node_id &&
                                          selectedNodeInfo.nodeType ===
                                            "Attachment") ||
                                        false
                                      }
                                      disabled={false} // Allow selection even if it's the source item
                                    />
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {generateCompleteTreePath({
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: undefined,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    })}
                                  </div>
                                </div>
                                <div>{item.short_description}</div>
                                {attachmentList.map((attachment, i) => (
                                  <div key={i} style={{ marginLeft: "20px" }}>
                                    {renderPreview(attachment)}
                                  </div>
                                ))}
                              </div>
                            );
                          }
                          default:
                            return null;
                        }
                      })}

                      {/* Substeps */}
                      {(substepsByStep[stepId] || []).map(
                        (substep, substepIndex) => {
                          const substepId = substep.sub_step_tree_node_id;

                          // Reset counters for each substep to ensure correct numbering within the substep
                          // globalRichTextCounter = 1;
                          // globalAttachmentCounter = 1;
                          // globalVideoCounter = 1;
                          // globalFormCounter = 1;
                          // globalCanvasCounter = 1;

                          const combinedItems = [
                            ...(richTexts[substepId] || []).map((item) => ({
                              ...item,
                              type: "richText",
                            })),
                            ...(forms[substepId] || []).map((item) => ({
                              ...item,
                              type: "form",
                            })),
                            ...(attachments[substepId] || []).map((item) => ({
                              ...item,
                              type: "attachment",
                            })),
                            ...(canvases[substepId] || []).map((item) => ({
                              ...item,
                              type: "canvas",
                            })),
                            ...(videos[substepId] || []).map((item) => ({
                              ...item,
                              type: "video",
                            })),
                          ];
                          const filteredItems = combinedItems; // Substeps don't filter out substeps

                          filteredItems.sort((a, b) => {
                            const orderA =
                              a.sibling_order ||
                              a.procedure_tree?.sibling_order;
                            const orderB =
                              b.sibling_order ||
                              b.procedure_tree?.sibling_order;

                            const orderCompare = compareSiblingOrders(
                              orderA,
                              orderB
                            );
                            if (orderCompare !== 0) return orderCompare;

                            // Fallback: compare created_at
                            const dateA = new Date(a.created_at);
                            const dateB = new Date(b.created_at);
                            return dateB - dateA; // latest comes first
                          });

                          // Global step number (same logic you already use for steps)
                          const stepsBeforeThisOne =
                            sortedSections
                              .slice(0, index)
                              .reduce((sectionAcc, s) => {
                                const steps =
                                  stepsBySection[s.section_tree_node_id] || [];
                                return sectionAcc + steps.length;
                              }, 0) + stepIndex;

                          const globalStepNumberForSubstep =
                            stepsBeforeThisOne + 1;

                          // Final substep label like Substep 5A
                          const substepLetter = String.fromCharCode(
                            65 + substepIndex
                          ); // A, B, C, ...

                          const globalSubstepLabel = `Substep ${globalStepNumberForSubstep}${substepLetter}`;

                          // Determine if this substep itself is the source item being moved
                          const isSourceSubstep =
                            sourceType === "Substep" &&
                            `${globalStepNumberForSubstep}${substepLetter}` ===
                              `${sourceNumber}${titleParts[
                                titleParts.length - 1
                              ].slice(-1)}`; // Compare full label

                          const maxSiblingOrder = Math.max(
                            ...filteredItems.map((item) =>
                              parseInt(
                                item.sibling_order ||
                                  item.procedure_tree?.sibling_order ||
                                  0
                              )
                            )
                          );

                          return (
                            <div
                              className="header-spacing"
                              key={substepId}
                              style={{ marginTop: "20px" }}
                            >
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        if (
                                          selectedNodeInfo &&
                                          (selectedNodeInfo.nodeId ===
                                            substepId ||
                                            selectedNodeInfo.substepIndex ===
                                              substepIndex)
                                        ) {
                                          setSelectedNodeInfo(null);
                                          setSelectionType(null);
                                        } else {
                                          setSelectedStepInfo(null);
                                          setSelectedNodeInfo({
                                            nodeId: substepId,
                                            sectionIndex: index,
                                            stepIndex: stepIndex,
                                            substepIndex: substepIndex,
                                            globalNodeNumber: `${globalStepNumberForSubstep}${substepLetter}`,
                                            nodeType: "Substep",
                                            direction: null,
                                            stepId,
                                          });
                                          setTargetSectionData({
                                            sectionId:
                                              section.section_tree_node_id,
                                            sectionIndex: index, // Add the section index
                                            siblingOrder: section.sibling_order,
                                            sectionTreeId:
                                              section.section_tree_node_id,
                                            stepId,
                                            stepTreeId: step.procedure_tree_ref,
                                            stepSiblingOrder:
                                              step.sibling_order ||
                                              step.procedure_tree
                                                ?.sibling_order,
                                            substepId,
                                            substepTreeId:
                                              substep.procedure_tree_ref,
                                            substepSiblingOrder:
                                              substep.sibling_order ||
                                              substep.procedure_tree
                                                ?.sibling_order,
                                            maxSiblingOrder,
                                          });
                                          setSelectionType("substep");
                                        }
                                      }}
                                      checked={
                                        selectedNodeInfo &&
                                        selectedNodeInfo.nodeId === substepId &&
                                        selectedNodeInfo.nodeType === "Substep"
                                      }
                                      disabled={false}
                                      style={
                                        selectedNodeInfo &&
                                        selectedNodeInfo.nodeId === substepId &&
                                        selectedNodeInfo.nodeType === "Substep"
                                          ? {
                                              accentColor: "#0066cc",
                                              backgroundColor: "#0066cc",
                                            }
                                          : {}
                                      }
                                    />
                                    <h2
                                      style={{
                                        margin: 0,
                                        color: "#0066cc",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {globalSubstepLabel}
                                    </h2>
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumberForSubstep} &gt; Substep{" "}
                                    {globalStepNumberForSubstep}
                                    {substepLetter}
                                  </div>
                                </div>

                                <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                              </div>

                              {/* Substep content */}
                              {filteredItems.map((item, itemIndex) => {
                                // Determine if this is the source item being moved (within substep)
                                const isSourceItem =
                                  (sourceType === "Rich Text" &&
                                    item.type === "richText" &&
                                    globalRichTextCounter === sourceNumber) ||
                                  (sourceType === "Form" &&
                                    item.type === "form" &&
                                    globalFormCounter === sourceNumber) ||
                                  (sourceType === "Canvas" &&
                                    item.type === "canvas" &&
                                    globalCanvasCounter === sourceNumber) ||
                                  (sourceType === "Video" &&
                                    item.type === "video" &&
                                    globalVideoCounter === sourceNumber) ||
                                  (sourceType === "Attachment" &&
                                    item.type === "attachment" &&
                                    globalAttachmentCounter === sourceNumber);

                                switch (item.type) {
                                  case "richText": {
                                    const currentRichTextNumber =
                                      globalRichTextCounter++;
                                    const richTextId =
                                      item.rich_text_node_id ||
                                      `rich-text-${currentRichTextNumber}`;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#0066cc",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Rich Text {currentRichTextNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={richTextId}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                if (
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    richTextId
                                                ) {
                                                  setSelectedNodeInfo(null);
                                                  setSelectionType(null);
                                                } else {
                                                  const nodeType = "Rich Text";
                                                  setSelectionType("node");

                                                  setSelectedNodeInfo({
                                                    nodeId: richTextId,
                                                    sectionIndex: index,
                                                    stepIndex: stepIndex,
                                                    nodeIndex: itemIndex,
                                                    globalNodeNumber:
                                                      currentRichTextNumber,
                                                    nodeType: "Rich Text",
                                                    direction: null,
                                                    stepId,
                                                  });

                                                  setTargetSectionData({
                                                    sectionId:
                                                      section.section_tree_node_id,
                                                    sectionIndex: index, // Add the section index
                                                    siblingOrder:
                                                      section.sibling_order,
                                                    sectionTreeId:
                                                      section.section_tree_node_id,
                                                    stepId,
                                                    stepTreeId:
                                                      step.procedure_tree_ref,
                                                    stepSiblingOrder:
                                                      step.sibling_order ||
                                                      step.procedure_tree
                                                        ?.sibling_order,
                                                    substepId,
                                                    substepTreeId:
                                                      substep.procedure_tree_ref,
                                                    substepSiblingOrder:
                                                      substep.sibling_order ||
                                                      substep.procedure_tree
                                                        ?.sibling_order,
                                                    elementSiblingOrder:
                                                      item.sibling_order ||
                                                      itemIndex + 1, // Use actual sibling_order or fallback to index + 1
                                                    elementId:
                                                      item.rich_text_node_id,
                                                    elementTreeId:
                                                      item.procedure_tree_ref,
                                                    maxSiblingOrder,
                                                  });
                                                }
                                              }}
                                              checked={
                                                selectionType === "node" &&
                                                selectedNodeInfo &&
                                                selectedNodeInfo.nodeId ===
                                                  richTextId &&
                                                selectedNodeInfo.nodeType ===
                                                  "Rich Text"
                                              }
                                              disabled={false} // Allow selection even if it's the source item
                                            />
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumberForSubstep} &gt;
                                            Substep {globalStepNumberForSubstep}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                          }}
                                        >
                                          {item.short_description}
                                        </div>
                                        <div
                                          style={{
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {item.category_data?.category_name}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div
                                            style={{ marginTop: "-6px" }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.rich_text_content,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                  case "video": {
                                    const currentVideoNumber =
                                      globalVideoCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#0066cc",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Video {currentVideoNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.video_tree_node_id ||
                                          `video-${currentVideoNumber}`
                                        }
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                if (
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.video_tree_node_id
                                                ) {
                                                  setSelectedNodeInfo(null);
                                                  setSelectionType(null);
                                                } else {
                                                  setSelectedStepInfo(null);
                                                  setSelectedNodeInfo({
                                                    nodeId:
                                                      item.video_tree_node_id,
                                                    sectionIndex: index,
                                                    stepIndex: stepIndex,
                                                    nodeIndex: itemIndex,
                                                    globalNodeNumber:
                                                      currentVideoNumber,
                                                    nodeType: "Video",
                                                    direction: null,
                                                    stepId,
                                                  });
                                                  setTargetSectionData({
                                                    sectionId:
                                                      section.section_tree_node_id,
                                                    siblingOrder:
                                                      section.sibling_order,
                                                    sectionTreeId:
                                                      section.section_tree_node_id,
                                                    stepId,
                                                    stepTreeId:
                                                      step.procedure_tree_ref,
                                                    stepSiblingOrder:
                                                      step.sibling_order ||
                                                      step.procedure_tree
                                                        ?.sibling_order,
                                                    substepId,
                                                    substepTreeId:
                                                      substep.procedure_tree_ref,
                                                    substepSiblingOrder:
                                                      substep.sibling_order ||
                                                      substep.procedure_tree
                                                        ?.sibling_order,
                                                    elementSiblingOrder:
                                                      item.sibling_order ||
                                                      itemIndex + 1, // Use actual sibling_order or fallback to index + 1
                                                    elementId:
                                                      item.video_tree_node_id,
                                                    elementTreeId:
                                                      item.procedure_tree_ref,
                                                    maxSiblingOrder,
                                                  });
                                                  setSelectionType("node");
                                                }
                                              }}
                                              checked={
                                                (selectionType === "node" &&
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.video_tree_node_id &&
                                                  selectedNodeInfo.nodeType ===
                                                    "Video") ||
                                                false
                                              }
                                              disabled={false} // Allow selection even if it's the source item
                                            />
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumberForSubstep} &gt;
                                            Substep {globalStepNumberForSubstep}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {renderVideo(item)}

                                        <div>{item.video_url}</div>

                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }

                                  case "form": {
                                    const currentFormNumber =
                                      globalFormCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Form {currentFormNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.form_tree_node_id ||
                                          `form-${currentFormNumber}`
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                if (
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.form_tree_node_id
                                                ) {
                                                  setSelectedNodeInfo(null);
                                                  setSelectionType(null);
                                                } else {
                                                  setSelectedStepInfo(null);
                                                  setSelectedNodeInfo({
                                                    nodeId:
                                                      item.form_tree_node_id,
                                                    sectionIndex: index,
                                                    stepIndex: stepIndex,
                                                    nodeIndex: itemIndex,
                                                    globalNodeNumber:
                                                      currentFormNumber,
                                                    nodeType: "Form",
                                                    direction: null,
                                                    stepId,
                                                  });
                                                  setTargetSectionData({
                                                    sectionId:
                                                      section.section_tree_node_id,
                                                    siblingOrder:
                                                      section.sibling_order,
                                                    sectionTreeId:
                                                      section.section_tree_node_id,
                                                    stepId,
                                                    stepTreeId:
                                                      step.procedure_tree_ref,
                                                    stepSiblingOrder:
                                                      step.sibling_order ||
                                                      step.procedure_tree
                                                        ?.sibling_order,
                                                    substepId,
                                                    substepTreeId:
                                                      substep.procedure_tree_ref,
                                                    substepSiblingOrder:
                                                      substep.sibling_order ||
                                                      substep.procedure_tree
                                                        ?.sibling_order,
                                                    elementSiblingOrder:
                                                      item.sibling_order ||
                                                      itemIndex + 1, // Use actual sibling_order or fallback to index + 1
                                                    elementId:
                                                      item.form_tree_node_id,
                                                    elementTreeId:
                                                      item.procedure_tree_ref,
                                                    maxSiblingOrder,
                                                  });
                                                  setSelectionType("node");
                                                }
                                              }}
                                              checked={
                                                (selectionType === "node" &&
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.form_tree_node_id &&
                                                  selectedNodeInfo.nodeType ===
                                                    "Form") ||
                                                false
                                              }
                                              disabled={false} // Allow selection even if it's the source item
                                            />
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumberForSubstep} &gt;
                                            Substep {globalStepNumberForSubstep}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }
                                  case "canvas": {
                                    const pages = getPages(item);

                                    const currentCanvasNumber =
                                      globalCanvasCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#0066cc",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Canvas {currentCanvasNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.canvas_tree_node_id ||
                                          `canvas-${currentCanvasNumber}`
                                        }
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                if (
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.canvas_tree_node_id
                                                ) {
                                                  setSelectedNodeInfo(null);
                                                  setSelectionType(null);
                                                } else {
                                                  setSelectedStepInfo(null);
                                                  setSelectedNodeInfo({
                                                    nodeId:
                                                      item.canvas_tree_node_id,
                                                    sectionIndex: index,
                                                    stepIndex: stepIndex,
                                                    nodeIndex: itemIndex,
                                                    globalNodeNumber:
                                                      currentCanvasNumber,
                                                    nodeType: "Canvas",
                                                    direction: null,
                                                    stepId,
                                                  });
                                                  setTargetSectionData({
                                                    sectionId:
                                                      section.section_tree_node_id,
                                                    siblingOrder:
                                                      section.sibling_order,
                                                    sectionTreeId:
                                                      section.section_tree_node_id,
                                                    stepId,
                                                    stepTreeId:
                                                      step.procedure_tree_ref,
                                                    stepSiblingOrder:
                                                      step.sibling_order ||
                                                      step.procedure_tree
                                                        ?.sibling_order,
                                                    substepId,
                                                    substepTreeId:
                                                      substep.procedure_tree_ref,
                                                    substepSiblingOrder:
                                                      substep.sibling_order ||
                                                      substep.procedure_tree
                                                        ?.sibling_order,
                                                    elementSiblingOrder:
                                                      item.sibling_order ||
                                                      itemIndex + 1, // Use actual sibling_order or fallback to index + 1
                                                    elementId:
                                                      item.canvas_tree_node_id,
                                                    elementTreeId:
                                                      item.procedure_tree_ref,
                                                    maxSiblingOrder,
                                                  });
                                                  setSelectionType("node");
                                                }
                                              }}
                                              checked={
                                                (selectionType === "node" &&
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.canvas_tree_node_id &&
                                                  selectedNodeInfo.nodeType ===
                                                    "Canvas") ||
                                                false
                                              }
                                              disabled={false} // Allow selection even if it's the source item
                                            />

                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumberForSubstep} &gt;
                                            Substep {globalStepNumberForSubstep}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {/* Display all pages vertically */}
                                        <CanvasDisplay
                                          pages={pages}
                                          hasUserContent={hasUserContent}
                                          getTextStyle={getTextStyle}
                                          stripHtmlPreserveFormatting={
                                            stripHtmlPreserveFormatting
                                          }
                                          estimateKonvaTextHeight={
                                            estimateKonvaTextHeight
                                          }
                                          formatListContent={formatListContent}
                                          hasNoteContent={hasNoteContent}
                                          hasTaskContent={hasTaskContent}
                                          calculateGroupHeight={
                                            calculateGroupHeight
                                          }
                                          calculateTextBlockWidth={
                                            calculateTextBlockWidth
                                          }
                                        />
                                      </div>
                                    );
                                  }
                                  case "attachment": {
                                    const attachmentList =
                                      item.attachments || [];
                                    if (attachmentList.length === 0)
                                      return null;

                                    const currentAttachmentNumber =
                                      globalAttachmentCounter++;

                                    const label = (
                                      <h2
                                        style={{
                                          color: "#0066cc",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Attachment {currentAttachmentNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.attachment_tree_node_id ||
                                          `attachment-${currentAttachmentNumber}`
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                if (
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.attachment_tree_node_id
                                                ) {
                                                  setSelectedNodeInfo(null);
                                                  setSelectionType(null);
                                                } else {
                                                  setSelectedNodeInfo({
                                                    nodeId:
                                                      item.attachment_tree_node_id,
                                                    sectionIndex: index,
                                                    stepIndex: stepIndex,
                                                    nodeIndex: itemIndex,
                                                    globalNodeNumber:
                                                      currentAttachmentNumber,
                                                    nodeType: "Attachment",
                                                    direction: null,
                                                    stepId,
                                                  });
                                                  setTargetSectionData({
                                                    sectionId:
                                                      section.section_tree_node_id,
                                                    siblingOrder:
                                                      section.sibling_order,
                                                    sectionTreeId:
                                                      section.section_tree_node_id,
                                                    stepId,
                                                    stepTreeId:
                                                      step.procedure_tree_ref,
                                                    stepSiblingOrder:
                                                      step.sibling_order ||
                                                      step.procedure_tree
                                                        ?.sibling_order,
                                                    substepId,
                                                    substepTreeId:
                                                      substep.procedure_tree_ref,
                                                    substepSiblingOrder:
                                                      substep.sibling_order ||
                                                      substep.procedure_tree
                                                        ?.sibling_order,
                                                    elementSiblingOrder:
                                                      item.sibling_order ||
                                                      itemIndex + 1, // Use actual sibling_order or fallback to index + 1
                                                    elementId:
                                                      item.attachment_tree_node_id,
                                                    elementTreeId:
                                                      item.procedure_tree_ref,
                                                    maxSiblingOrder,
                                                  });
                                                  setSelectionType("node");
                                                }
                                              }}
                                              checked={
                                                (selectionType === "node" &&
                                                  selectedNodeInfo &&
                                                  selectedNodeInfo.nodeId ===
                                                    item.attachment_tree_node_id &&
                                                  selectedNodeInfo.nodeType ===
                                                    "Attachment") ||
                                                false
                                              }
                                              disabled={false} // Allow selection even if it's the source item
                                            />
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumberForSubstep} &gt;
                                            Substep {globalStepNumberForSubstep}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                        {attachmentList.map((attachment, i) => (
                                          <div
                                            key={i}
                                            style={{ marginLeft: "20px" }}
                                          >
                                            {renderPreview(attachment)}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
            </div>
          );
        })}

      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default ProcedureChildCopy;
